<template>
    <div class="header">
        <img class="m-auto d-block" v-bind:src="getBrandingOptions().logoUrl"  alt="">
    </div>
</template>

<script>
    import {getBrandingOptions} from '@/utils/getBrandingOptions.js';
    export default {
        methods: {
            getBrandingOptions
        },
    }
</script>